import { localStorageService } from 'common/utilities/LocalStorageService';

const enableAuthLog = localStorageService.getItem('enableAuthLog') === 'true';

export function authlog(message: string) {
  if (enableAuthLog) {
    const timestamp = new Date().toLocaleString();
    // eslint-disable-next-line no-console
    console.log(`[Auth] [${timestamp}] ${message}`);
  }
}
